import { get, post } from "../GenericServices";

const ImportPlanning = {
  closeMonth: () => {
    return post(`import-planning/close-month`);
  },
  uploadTimesheet: () => {
    return post(`import-planning/import-timesheet`);
  },
  uploadCosts: (formData) => {
    return post(`import-planning/import-cost`, formData);
  },
  uploadCostsPlan: (formData) => {
    return post(`import-planning/import-cost-plan`, formData);
  },
  uploadCostsPlanDetail: (id, formData) => {
    return post(`import-planning/import-cost-plan/${id}`, formData);
  },
  uploadInvoicePlan: (formData) => {
    return post(`import-planning/import-invoice-plan`, formData);
  },
  downloadProjectNotApproved: () => {
    return post(`import-planning/project-not-approved-report`);
  },
  lastFreeze: () => {
    return get(`import-planning/status`);
  },
  copyPlanningm1: () => {
    return post(`import-planning/copy-planning`);
  },
  editFreezedMonth: () => {
    return post(`import-planning/open-planning`);
  },
  storeServiceBasePrice: () => {
    return post(`import-planning/store-service-base-price`);
  },
  recalculateCosts: () => {
    return post(`import-planning/recalculate-costs`);
  },
  generateETC: () => {
    return post(`import-planning/generate-etc`);
  },
};

export default ImportPlanning;
